<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">Nominations</h4>
        <h5 class="text-primary">[{{ proposalName }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-blue me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          ">
          <button class="btn btn-primary me-2" (click)="onSubmit()">
            <i class="pi pi-save me-1"></i> Save
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <div class="container-fluid">
    <!-- Header Section -->

    <!-- Document Upload Section -->
    <div class="row mb-4">
      <div class="col-lg-8">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">
            <div class="d-flex align-items-center mb-3">
              <i class="pi pi-file text-primary me-2"></i>
              <h5 class="card-title mb-0">Upload Document</h5>
            </div>

            <p class="text-muted mb-4">
              Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG
              format (Max size: 200MB)
            </p>

            <!-- Upload Area -->
            <!-- <div class="upload-container mb-4" *ngIf="
                stepDetails?.is_initiator ||
                stepDetails?.is_approver ||
                stepDetails?.is_recommender ||
                (stepDetails?.step_status != 'approved' && userID == 6)
              ">
              <div class="upload-area p-4 text-center border rounded">
                <p-fileUpload mode="basic" chooseLabel="Browse Files" (uploadHandler)="onUpload($event)" [auto]="true"
                  [customUpload]="true" #fileUpload [multiple]="false" [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'"
                  [maxFileSize]="209715200" styleClass="p-button-rounded p-button-outlined">
                </p-fileUpload>
              </div>
            </div> -->
            <app-upload-document></app-upload-document>

            <!-- Uploaded File Display -->
            <div *ngIf="uploadedFileName || uploadedUrl">
              <div class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="pi pi-file me-3 text-primary" style="font-size: 1.5rem"></i>
                  <div>
                    <p class="mb-0 fw-semibold">
                      <a [href]="apiUrl + uploadedUrl" target="_blank" class="text-decoration-none">
                        {{ uploadedFileName || getFileName(uploadedUrl) }}
                      </a>
                    </p>
                    <small class="text-muted">Uploaded successfully</small>
                  </div>
                </div>
                <div class="d-flex gap-2">
                  <a [href]="apiUrl + uploadedUrl" target="_blank" class="btn btn-sm btn-outline-primary"
                    *ngIf="uploadedUrl">
                    <i class="pi pi-eye"></i>
                  </a>
                  <!-- <button class="btn btn-sm btn-outline-danger"> -->
                  <i class="pi pi-times" (click)="clearUpload(fileUpload)" *ngIf="uploadedFileName"></i>
                  <!-- </button> -->
                </div>
              </div>
            </div>

            <!-- No Files State -->
            <div *ngIf="
                !uploadedFileName &&
                !uploadedUrl &&
                !(
                  stepDetails?.is_initiator ||
                  stepDetails?.is_approver ||
                  stepDetails?.is_recommender ||
                  (stepDetails?.step_status != 'approved' && userID == 6)
                )
              " class="no-file-placeholder p-3 text-center bg-light rounded">
              <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem"></i>
              <p class="mb-0 text-muted">No files uploaded</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container>
      <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()"
        [isDeletable]="false" [showAddButton]="
          stepDetails?.is_approver ||
          stepDetails?.is_initiator ||
          stepDetails.is_recommender ||
          (stepDetails?.step_status != 'approved' && userID == 6)
        " [showActions]="
          stepDetails?.is_approver ||
          stepDetails?.is_initiator ||
          stepDetails?.is_recommender ||
          (stepDetails?.step_status != 'approved' && userID == 6)
        " [isEditable]="
          stepDetails?.is_approver ||
          stepDetails?.is_initiator ||
          stepDetails?.is_recommender ||
          (stepDetails?.step_status != 'approved' && userID == 6)
        " [title]="title" (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="
          stepDetails?.is_approver ||
          stepDetails?.is_initiator ||
          stepDetails?.is_recommender ||
          (stepDetails?.step_status != 'approved' && userID == 6)
        " (viewEventRow)="viewSystem($event)" (deleteEventRow)="showDeletePopup($event)"
        (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
      </app-data-table>
    </ng-container>
  </div>
</div>

<p-dialog header="Create Role Assignment" [(visible)]="showDialog" [modal]="true"
  [style]="{ width: '600px', height: 'auto' }" [closable]="true" [dismissableMask]="true" [maximizable]="true"
  appendTo="body">
  <form [formGroup]="roleForm" (ngSubmit)="onSubmitadd()" class="form-wrapper">
    <!-- Directorate Dropdown -->
    <div class="mt-4 mb-3">
      <label for="directorate"><b>Directorate</b></label>
      <p-dropdown [options]="unitList" optionLabel="name" optionValue="id" formControlName="directorate"
        placeholder="Select Directorate" appendTo="body" class="w-100" (onChange)="onUnitChange($event)">
      </p-dropdown>
      <div class="text-danger mt-1" *ngIf="
              roleForm.get('directorate')?.touched &&
              roleForm.get('directorate')?.hasError('required')
            ">
        Directorate is required.
      </div>
    </div>

    <!-- User Dropdown -->
    <div class="mt-4 mb-3">
      <label for="user"><b>User</b></label>
      <p-dropdown [options]="userList" optionLabel="first_name" optionValue="id" formControlName="user"
        placeholder="Select User" appendTo="body" class="w-100">
        <ng-template let-user pTemplate="item">
          <div class="list-group-item list-group-item-action col-md-6">
            <small>
              {{ user.hrcdf_designation }} {{ user.first_name }}
              {{ user.last_name }} - {{ user.loginname }}</small>
          </div>
        </ng-template>
      </p-dropdown>
      <div class="text-danger mt-1" *ngIf="
              roleForm.get('user')?.touched &&
              roleForm.get('user')?.hasError('required')
            ">
        User is required.
      </div>
    </div>

    <!-- Role Name -->
    <div class="mt-4 mb-3">
      <label><b>Role Name</b></label>
      <input type="text" class="form-control" formControlName="roleName" maxlength="50" />
      <div *ngIf="roleForm.get('roleName')?.touched">
        <small class="text-danger" *ngIf="roleForm.get('roleName')?.hasError('required')">
          Role name is required.
        </small>
      </div>
    </div>

    <!-- Contact Details -->
    <div class="mt-4 mb-3">
      <label><b>Contact Details</b></label>
      <textarea class="form-control" formControlName="contact" maxlength="100" rows="4"></textarea>
      <div *ngIf="roleForm.get('contact')?.touched">
        <small class="text-danger" *ngIf="roleForm.get('contact')?.hasError('required')">
          Contact details are required.
        </small>
      </div>
    </div>




    <!-- Buttons -->
    <div class="d-flex justify-content-end mt-3 btn-wrapper">
      <button type="submit" class="btn btn-primary me-2" [disabled]="roleForm.invalid">
        Save
      </button>
    </div>
  </form>
</p-dialog>

<p-dialog [header]="viewMode ? 'View Role' : 'Update Role'" [(visible)]="isUpdatedialog" [modal]="true"
  [maximizable]="true" [style]="{ width: '600px', height: 'auto' }" [closable]="true" [dismissableMask]="true" appendTo="body"
  [contentStyle]="{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        'justify-content': 'space-between'
      }">
   <form [formGroup]="roleForm" (ngSubmit)="onSubmitEq()" class="form-wrapper">
    <!-- Directorate Dropdown -->
    <div class="mt-4 mb-3">
      <label for="directorate"><b>Directorate</b></label>
      <p-dropdown [options]="unitList" optionLabel="name" optionValue="id" formControlName="directorate"
        placeholder="Select Directorate" appendTo="body" class="w-100" (onChange)="onUnitChange($event)">
      </p-dropdown>
      <div class="text-danger mt-1" *ngIf="
              roleForm.get('directorate')?.touched &&
              roleForm.get('directorate')?.hasError('required')
            ">
        Directorate is required.
      </div>
    </div>

    <!-- User Dropdown -->
    <div class="mt-4 mb-3">
      <label for="user"><b>User</b></label>
      <p-dropdown [options]="userList" optionLabel="first_name" optionValue="id" formControlName="user"
        placeholder="Select User" appendTo="body" class="w-100">
        <ng-template let-user pTemplate="item">
          <div class="list-group-item list-group-item-action col-md-6">
            <small>
              {{ user.hrcdf_designation }} {{ user.first_name }}
              {{ user.last_name }} - {{ user.loginname }}</small>
          </div>
        </ng-template>
      </p-dropdown>
      <div class="text-danger mt-1" *ngIf="
              roleForm.get('user')?.touched &&
              roleForm.get('user')?.hasError('required')
            ">
        User is required.
      </div>
    </div>

    <!-- Role Name -->
    <div class="mt-4 mb-3">
      <label><b>Role Name</b></label>
      <input type="text" class="form-control" formControlName="roleName" maxlength="50" />
      <div *ngIf="roleForm.get('roleName')?.touched">
        <small class="text-danger" *ngIf="roleForm.get('roleName')?.hasError('required')">
          Role name is required.
        </small>
      </div>
    </div>

    <!-- Contact Details -->
    <div class="mt-4 mb-3">
      <label><b>Contact Details</b></label>
      <textarea class="form-control" formControlName="contact" maxlength="100" rows="4"></textarea>
      <div *ngIf="roleForm.get('contact')?.touched">
        <small class="text-danger" *ngIf="roleForm.get('contact')?.hasError('required')">
          Contact details are required.
        </small>
      </div>
    </div>




    <!-- Buttons -->
    <div class="d-flex justify-content-end mt-3 btn-wrapper">
      <button type="submit" class="btn btn-primary me-2" [disabled]="roleForm.invalid">
        Save
      </button>
    </div>
  </form>
</p-dialog>

<p-dialog header="Delete Incubator" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }"
  [maximizable]="true">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete Incubator ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()"
      class="mt-2">
    </p-button>
  </div>
</p-dialog>